import { DATE_FORMAT_YYYY_MM_DD } from '@shared/constants/otherConstants';
import dayjs from 'dayjs';

export function formatDateRange(rangeObject) {
    const fromDate = rangeObject?.from && dayjs(rangeObject.from).format(DATE_FORMAT_YYYY_MM_DD);
    const toDate = rangeObject?.to && dayjs(rangeObject.to).format(DATE_FORMAT_YYYY_MM_DD);

    return [fromDate, toDate];
}
